import { CmsImage, CmsLink } from 'src/types'
import * as Styles from './MarqueeLaunch.style'
import Text from 'src/components/atoms/Text/Text'
import { motion } from 'framer-motion'
import FlexWrapper from 'src/components/_layout/FlexWrapper/FlexWrapper'
import Image from 'src/components/atoms/Image/Image'
import marqueeLogo from 'src/assets/images/fvficon.svg'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperInstance, { Autoplay, EffectFade } from 'swiper'
import RichText from 'src/components/atoms/RichText/RichText'
import Padder from 'src/components/_layout/Padder/Padder'
import LineLink from 'src/components/atoms/LineLink'

type MarqueeLaunchProps = {
    titles: { title: string }[]
    image: CmsImage
    description: string
    link: CmsLink
}

SwiperInstance.use([Autoplay])

const MarqueeLaunch: React.FC<MarqueeLaunchProps> = ({
    titles,
    image,
    description,
    link,
}) => {
    return (
        <Styles.Wrapper>
            <Styles.MarqueeWrapper>
                <Swiper
                    autoplay={{ delay: 1 }}
                    slidesPerView="auto"
                    speed={10000}
                    loop
                    spaceBetween={0}
                    centeredSlides
                    allowTouchMove={false}
                >
                    {titles.map(({ title }, index) => (
                        <SwiperSlide key={index}>
                            <FlexWrapper
                                css={{ gap: '$colWidth' }}
                                align="center"
                            >
                                <Text
                                    textVariant="titleMedium"
                                    key={index}
                                    css={{ height: '0.8em' }}
                                >
                                    {title}
                                </Text>
                                <Styles.MarqueeIcon>
                                    <Image src={marqueeLogo} alt={'logo'} />
                                </Styles.MarqueeIcon>
                            </FlexWrapper>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </Styles.MarqueeWrapper>
            <Styles.ContentWrapper>
                <Styles.ImageWrapper>
                    <Image src={image.url} alt={image.alt} />
                </Styles.ImageWrapper>
                <Styles.TextWrapper>
                    <Padder top="sm">
                        <RichText
                            textVariant="baseItalic"
                            htmlString={description}
                        />
                        <FlexWrapper justify="end">
                            <LineLink {...link} />
                        </FlexWrapper>
                    </Padder>
                </Styles.TextWrapper>
            </Styles.ContentWrapper>
        </Styles.Wrapper>
    )
}

export default MarqueeLaunch
